<template>
  <div class="data-list">
    <div class="data-list-header">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">进行中活动</div>
            <div class="number">{{panelData.inProgress}}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">已结束活动</div>
            <div class="number">{{panelData.end}}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与职员</div>
            <div class="number">{{panelData.joinStaff}}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">拉新人数</div>
            <div class="number">{{panelData.pullNew}}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与人数</div>
            <div class="number">{{panelData.joinNum}}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="120px"
            size="mini"
          >
            <el-form-item label="区域" prop="orgName">
              <el-input
                class="form-input"
                v-model="searchForm.orgName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="cusName">
              <el-input
                class="form-input"
                v-model="searchForm.cusName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商经营状态" prop="cusStatus" >
              <el-select v-model="searchForm.cusStatus" clearable @change="onSearch">
                <el-option v-for="item in cusStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="门店" prop="shopName">
              <el-input
                class="form-input"
                v-model="searchForm.shopName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="门店是否有效" prop="shopStatus">
              <el-select v-model="searchForm.shopStatus" clearable @change="onSearch">
                <el-option v-for="item in shopStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="职员编码" prop="code">
              <el-input
                class="form-input"
                v-model="searchForm.code"
                clearable
                placeholder="请输入编码"
              ></el-input>
            </el-form-item>
            <el-form-item label="职员名称" prop="name">
              <el-input
                class="form-input"
                v-model="searchForm.name"
                clearable
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否离职" prop="online">
              <el-select v-model="searchForm.online" clearable @change="onSearch">
                <el-option v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="空数据屏蔽" prop="nullData">
              <el-select  v-model="searchForm.nullData" multiple clearable >
                <el-option v-for="item in nullData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="截止时间" prop="updatedTime">
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="orgName" label="区域" align="center" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="cusName" label="经销商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cusStatus" label="经销商经营状态" width="120" align="center"></el-table-column>
          <el-table-column prop="shopName" label="门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shopStatus" label="门店是否有效" align="center" width="110"></el-table-column>

          <el-table-column prop="code" label="职员编码" align="center" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="name" label="职员名称" align="center" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="onlineString" label="是否离职" align="center" width="80"></el-table-column>
          <el-table-column label="活动创建数" width="120" align="center">
            <template v-slot="scope">
              <span class="create-name" @click="jump(scope.row)">{{scope.row.createNum}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="activityJoinNum" label="参与活动数"  width="120" align="center"></el-table-column>
          <el-table-column label="用户拉新数/人" align="center" width="120">
            <template v-slot="scope">
              {{scope.row.pullNew || 0}}/{{scope.row.pullNewPeople || 0}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="joinNum" label="参与用户数" align="center"></el-table-column> -->
          <el-table-column prop="joinNum" label="报名数/人" align="center" width="90">
            <template v-slot="scope">
              {{scope.row.joinNum || 0}}/{{scope.row.joinNumPeople || 0}}
            </template>
          </el-table-column>
          <el-table-column label="核销数/人" align="center" width="90">
            <template v-slot="scope">
              {{scope.row.verificationNum || 0}}/{{scope.row.verificationNumPeople || 0}}
            </template>
          </el-table-column>
          <el-table-column label="退款数/人" align="center" width="90">
            <template v-slot="scope">
              {{scope.row.refundNum || 0}}/{{scope.row.refundNumPeople || 0}}
            </template>
          </el-table-column>
          <el-table-column label="H5登录次数" prop="loginTimes" align="center" width="100"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
export default {
  name: "employeeList",
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        orgName: "",
        cusName: "",
        cusStatus: 1,
        shopName: "",
        shopStatus:"",
        code: "",
        name: "",
        online: 0,
        startTime: "",
        endTime: "",
        nullData: []
      },
      parentIdCode: "",
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {
        online: 0,
        cusStatus: 1,
      },
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      cusStatus:[
         {value: '', label: '全部'},
         {value: 1, label: '正常营业'},
         {value: 2, label: '预停业'},
         {value: 3, label: '已停业'},
         {value: 4, label: '预营业'},
         {value: 5, label: '未开业停用'},
         {value: 6, label: '经营异常'},
      ],
      shopStatus: [
        {value: '', label: '全部'},
        {value: 0, label: '否'},
        {value: 1, label: '是'},
      ],
      statusOptions: [
        {value: '', label: '全部'},
        {value: 0, label: '否'},
        {value: 1, label: '是'},
      ],
      nullData: [
        {value: 'createNumNull', label: '创建数'},
        {value: 'activityJoinNumNull', label: '参与数'},
        {value: 'pullNewNull', label: '拉新数'},
        {value: 'joinNumNull', label: '报名数'}
      ]
    };
  },
  methods: {
    init() {
      this.getOrgBoardInfo()
      this.onSearch();
    },
    getOrgBoardInfo() {
      if (this.parentIdCode) {
        this.$api.dataReport.staffBoardInfo(this.parentIdCode)
        .then( res => {
          this.panelData = res.data
        })
      }else {
        this.$api.dataReport.orgBoardInfo()
        .then( res => {
          this.panelData = res.data
        })
      }
     
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          parentIdCode: this.parentIdCode,
        },
      };
      this.$api.dataReport.staffDateReportPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate(this.$route.query)
      this.filterParam = {
         parentIdCode: this.parentIdCode,
      };
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {
         parentIdCode: this.parentIdCode
      };
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === 'nullData') {
         this.searchForm.nullData.forEach(item => {
          this.filterParam[item] = 1
         })
        }
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          name: "dealerList",
          params: row,
        });
      }else if (actionType == 1) {
        let params = {
          ...this.filterParam
        };
          this.$api.common.doExport('staffDateReportPageList', params).then(() => {
            this.$message.success('导出操作成功，请前往导出记录查看详情');
        });
      }
    },
    jump(row) {
      this.openSubPage({
        path: '/activity/list',
        query: {userId: row.userId}
      });
    },
    isArrayEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    },
    initDate(query) {
      if (query.updatedTime && query.updatedTime.length) {
        this.searchForm.startTime = query.updatedTime[0]
        this.searchForm.endTime = query.updatedTime[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
        this.$refs.dateRef.reset()
      }
    }
  },
  filters: {},
  watch: {
    $route: {
      handler(val, olv) {
        let query = val.query;
        if (
          olv.path == "/dataReport/store" &&
          JSON.stringify(query) != "{}" &&
          (query.code != this.parentIdCode ||
            !this.isArrayEqual(query.updatedTime || [], this.searchForm.updatedTime || []))
        ) {
          this.parentIdCode = query.code || "";
          this.initDate(query)
          this.init();
        }
      },
    },
  },
  mounted() {
    this.parentIdCode = this.$route.query.code || "",
    this.initDate(this.$route.query)
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .date-input {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
        text-align: center;
        padding: 6px 0;
    }
  }
  .create-name {
    cursor: pointer;
    color: #24c69a;
  }
  .nullData /deep/ .el-input{
    width: 400px
  }
  
}
</style>
